import React from 'react';
import { Button, BackButton, ResultValue, PrintButton } from '../Components/Simple';
import {
    BasicInformation, ClaimDetails, DialysisDetails,
    FactorAndAdjustments, PricingAmounts, ServiceLineItems, PricingErrors
} from '../Components/Combined/Results';
import { ESRD as modelType } from '../Constants/modelTypes';
import { formatStringAsCurrency, formatDateString } from '../Utils/stringUtils';
import { API_DATE_STRING_FORMAT, DATE_STRING_FORMAT } from '../Constants/stringFormats';
import { useNavigate, useLocation } from 'react-router-dom';
import usePrintOrientation from '../Hooks/usePrintOrientation';
import Protect from '../Components/Combined/Protect';
import { HIDE } from '../Constants/protectionBehaviors';
import { EOB_VIEW } from '../Constants/moduleNames';
import { enableEOB } from '../Utils/features';

export default function ESRDResult() {
    const [_orientation, _setOrientation] = usePrintOrientation('landscape');
    const navigate = useNavigate();
    const location = useLocation();
    const { result, calendarYear, lines } = location.state;

    const processedDate = new Date();

    const handleNavigateToEOBGenerator = () => {
        navigate('/EOB', {
            state: {
                processedDate,
                pricerType: modelType,
                lines: lines.map((line, i) => {
                    const responseLine = result.services[i]
                    return {
                        dateOfService: formatDateString(line.serviceDate, API_DATE_STRING_FORMAT, DATE_STRING_FORMAT) || "",
                        serviceCode: responseLine.procCode || responseLine.revCode || "",
                        serviceDescription: (responseLine.procCode ? responseLine.procCodeDescription : responseLine.revCodeDescription) || "",
                        qty: parseFloat(responseLine.adjUnits) || "",
                        billedAmount: parseFloat(responseLine.billed) || 0,
                        allowedAmount: parseFloat(responseLine.medicareAllowed) || 0,
                        initialMaxShiftAmount: 0
                    }
                })
            }
        });
    };

    return (<div className="py-2">
        <div className="row g-0 sticky top border-bottom">
            <div className="row justify-content-between g-0">
                <div className="col-auto">
                    <PrintButton />
                </div>
                <div className="col-auto">
                    <Protect module={EOB_VIEW} behavior={HIDE} >
                        {enableEOB && <Button className="btn btn-success" onClick={handleNavigateToEOBGenerator} text="Generate EOB" />}
                    </Protect>
                </div>
                <div className="col-auto">
                    <BackButton />
                </div>
            </div>
            <div className="row my-2 g-0">
                <div className="col">
                    <h2>Dialysis Pricer - Pricing Outputs</h2>
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-md-6">
                <ResultValue label="Medicare Allowed Amount" value={formatStringAsCurrency(result.totalMedicareAllowed)} labelClassName="fs-4 fw-500" valueClassName="fs-4 fw-500" />
            </div>
        </div>
        <PricingErrors result={result} totalMedicareAllowed={result.totalMedicareAllowed} />
        <div className="row">
            <div className="col-md">
                <div className="row my-2">
                    <div className="col">
                        <BasicInformation calendarYear={calendarYear} result={result} model={modelType} processedDate={processedDate} />
                    </div>
                </div>
                <div className="row my-2">
                    <div className="col">
                        <ClaimDetails result={result} model={modelType} />
                    </div>
                </div>
            </div>
            <div className="col-md">
                <div className="row my-2">
                    <div className="col">
                        <DialysisDetails result={result} model={modelType} />
                    </div>
                </div>
                <div className="row my-2">
                    <div className="col">
                        <FactorAndAdjustments result={result} model={modelType} />
                    </div>
                </div>
                <div className="row my-2">
                    <div className="col">
                        <PricingAmounts result={result} model={modelType} />
                    </div>
                </div>
            </div>
        </div>
        <div className="page-break-here"></div>
        <div className="row my-2">
            <div className="col">
                <ServiceLineItems result={result} inputLines={lines} model={modelType} />
            </div>
        </div>
    </div>
    );
}
